export const PERSONAL = 'personal'
export const REFI = 'refi'
export const INSCHOOL = 'in_school'
export const MORTGAGE_PURCHASE = 'purchase'
